exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ant-select-item-option {\n  font-size: 12px;\n}\n.ant-select-item-option-content {\n  overflow: visible;\n  white-space: pre-wrap;\n  word-break: break-word;\n  font-size: 12px;\n}\n.ant-select-tree {\n  font-size: 12px;\n}\n.ant-cascader-picker {\n  font-size: 12px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/stylus-loader!./src/AntD/assets/stylus/antdChange.styl
// module id = 5286
// module chunks = 0